import { useCallback, useEffect, useMemo, useState } from "react";
import { cvAdminApi } from "../api/cvAdminApi";
import { safeMsg } from "../utils/cvUtils";

export function useCvSubmissionsList({ q, statusValue, perPage = 200, debounceMs = 350 }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const [qDebounced, setQDebounced] = useState(q || "");
  useEffect(() => {
    const t = setTimeout(() => setQDebounced(q || ""), debounceMs);
    return () => clearTimeout(t);
  }, [q, debounceMs]);

  const params = useMemo(() => {
    const p = {
      status: statusValue || "",
      per_page: perPage,
    };
    if ((qDebounced || "").trim()) p.q = qDebounced.trim();
    return p;
  }, [qDebounced, statusValue, perPage]);

  const fetchList = useCallback(async () => {
    setErr("");
    setLoading(true);
    try {
      const payload = await cvAdminApi.listSubmissions(params);

      const data =
        (Array.isArray(payload?.data) && payload?.data) ||
        (Array.isArray(payload?.data?.data) && payload?.data?.data) ||
        [];

      setRows(
        data.map((r) => ({
          id: r.user_id ?? r.id,
          user_id: r.user_id ?? r.id,
          employee_code: r.employee_code,
          name: r.name,
          email: r.email,
          status: r.status,
          submitted_at: r.submitted_at,
          editable_until: r.cv_editable_until,
          window_open: r.window_open,
          updated_at: r.updated_at,
        }))
      );
    } catch (e) {
      setErr(safeMsg(e));
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  return { rows, loading, err, fetchList };
}
